// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.footer-wrapper {
  display: flex;
  align-items: center;
  padding: 15px;
  width: 100%;
}

.contact-me-wrapper {
  flex-direction: row-reverse;
}

.contact-me-wrapper > div:nth-child(1) {
  flex-direction: column-reverse;
}
.footer-contact-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  max-width: 350px;
}
.footer-contact-info > h3 {
  color: white;
}
.footer-contact-info > div {
  display: flex;
  justify-content: center;
}

.footer-contact-info > a {
  border: white solid 1px;
  border-radius: 5px;
}

.footer-contact-info p {
  color: white;
}

.footer-contact-info .social-nav {
  width: 100%;
}

.footer-signature {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-top: 50px;
}
@media (max-width: 450px) {
  .footer-contact-info {
    flex-direction: column;
    align-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/elements/footer-nav/footer-nav.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF","sourcesContent":["footer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n\n.footer-wrapper {\n  display: flex;\n  align-items: center;\n  padding: 15px;\n  width: 100%;\n}\n\n.contact-me-wrapper {\n  flex-direction: row-reverse;\n}\n\n.contact-me-wrapper > div:nth-child(1) {\n  flex-direction: column-reverse;\n}\n.footer-contact-info {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  max-width: 350px;\n}\n.footer-contact-info > h3 {\n  color: white;\n}\n.footer-contact-info > div {\n  display: flex;\n  justify-content: center;\n}\n\n.footer-contact-info > a {\n  border: white solid 1px;\n  border-radius: 5px;\n}\n\n.footer-contact-info p {\n  color: white;\n}\n\n.footer-contact-info .social-nav {\n  width: 100%;\n}\n\n.footer-signature {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 50px;\n}\n@media (max-width: 450px) {\n  .footer-contact-info {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
